import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="list"
export default class extends Controller {
  connect() {
    console.log('list controller connected');
  }

  disconnect() {
    console.log('list controller disconnected');
  }

  initialize() {
    console.log('list controller initialize');
    this.currentRow = null;

    // in some scenarios, when navigating back to a list page the previous current row is still highlighted
    // need to set `currentRow` to match this so that any movement up and down the list starts from this
    // highlighted row
    this.refreshCurrentRowIndex();
  }

  next() {
    console.log('next');
    this.changeRow(1);
  }

  previous() {
    console.log('previous');
    this.changeRow(-1);
  }

  open() {
    if (this.currentRow !== null) {
      let link = this.element.getElementsByClassName("item-link")[this.currentRow];
      console.log('open', link.href);
      Turbo.visit(link.href);
    }
  }

  changeRow(increment) {
    console.log('looking for rows in', this.element);
    let rows = this.element.querySelectorAll(".item-list-item");
    console.log('found rows?', rows);
    let rowCount = rows.length;
    let nextRow;

    if (this.currentRow === null) {
      nextRow = increment - 1;
    } else {
      nextRow = this.currentRow + increment;
    }

    if (nextRow < 0) {
      nextRow = 0;
    } else if (nextRow >= rowCount) {
      nextRow = rowCount - 1;
    }

    if (nextRow != this.currentRow) {
      if (this.currentRow !== null) {
        rows[this.currentRow].classList.remove("current-list-item");
      }
      rows[nextRow].classList.add("current-list-item");

      if (!this.isInViewport(rows[nextRow])) {
        // if it's the first item in the list then scroll back to the top of the page,
        // otherwise just ensure the new current item is in view.
        // note: if we use this controller on any pages that aren't the index/main list pages
        // then we might want to be able to control different behaviour here. e.g. if we added
        // keyboard navigation to the list of agents at an agency (so agency#show) then there could be
        // lots of other content above the list, and so wouldn't necessarily want to jump all the way to the top
        // of the page.
        if (nextRow === 0) {
          window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
          rows[nextRow].scrollIntoView();
        }
      }

      this.currentRow = nextRow;
    }

    console.log("row changed to", this.currentRow);
  }

  isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
  }

    refreshCurrentRowIndex() {
        let rows = Array.from(this.element.querySelectorAll(".item-list-item"));
        const currentlySelectedRow = rows.findIndex((row, index) => row.classList.contains("current-list-item"));
        if (currentlySelectedRow !== -1) {
            console.log("current row refreshed to", currentlySelectedRow);
            this.currentRow = currentlySelectedRow;
        }
    }
}
